// extracted by mini-css-extract-plugin
export default {"container":"style_container__VpSM2","center":"style_center__uTOJv","cards":"style_cards__OKk0Z","left":"style_left__ON4qL","btn":"style_btn__NGERT"};